import { gsap, ScrollTrigger } from "@/composeables/gsap";

// Bronze-Gradient der .cta--big-Variante scrollgekoppelt verschieben, damit der
// helle Peak wie eine wandernde Reflexion übers "Metall" gleitet.
//
// Technik: --shine ist eine 0..1-Custom-Property, die ScrollTrigger scrubbt.
// Die SCSS-Seite mappt --shine auf background-position (breiter background-size)
// und die Position des Glanz-Streifens. Kein Layout-Reflow, nur Paint.
export const init = () => {

    const buttons = gsap.utils.toArray(".cta--big");
    if (!buttons.length) return;

    // Kein Scroll-Glanz bei reduzierter Bewegung: --shine bleibt auf dem
    // Ruhewert (0.5 = zentrierter Peak, siehe SCSS-Default).
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    buttons.forEach(function (button) {

        gsap.fromTo(
            button,
            { "--shine": 0 },
            {
                "--shine": 1,
                ease: "none",
                scrollTrigger: {
                    trigger: button,
                    // Volle Fahrt: von "Button betritt Viewport unten" bis
                    // "Button verlässt oben" — der Glanz wandert über die
                    // gesamte Sichtbarkeitsdauer einmal durch.
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    invalidateOnRefresh: true,
                },
            }
        );

    });
}

export default init;
